import { Anchor } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import useDynamicRefs from '../../hooks/use_dynamic_refs';
import { hashGenerator } from '../../lib/hashGenerator';
import { getIsMobile, getIsWebview } from '../../redux/window';
import { ContentWrapper } from '../content_wrapper/content_wrapper';
import { MOBILE_HEADER_HEIGHT_APPROX } from '../header/header_mobile';
import SvgFishingReport from '../svg/fishing_report';
import SvgInfo from '../svg/info';
import SvgLakes from '../svg/lakes';
import SvgProducts from '../svg/products';
import SvgVideoFolder from '../svg/video_folder';
import { StatePageIds } from './state_detail';
import styles from './state_detail_nav.less';

interface StateDetailNavProps {
  mediaCount: number;
  hasLearnMoreSection: boolean;
}

export const StateDetailNav = (props: StateDetailNavProps) => {
  const { mediaCount, hasLearnMoreSection } = props;
  const isMobile = useSelector(getIsMobile);
  const isWebView = useSelector(getIsWebview);

  const { getRef, setRef } = useDynamicRefs();

  return (
    <div className={styles.fullWidthBackground}>
      <ContentWrapper className={styles.contentWrapper}>
        <Anchor
          key={`${hashGenerator(`statePageNav${isMobile}${mediaCount}`)}`}
          targetOffset={200}
          showInkInFixed={false}
          className={styles.anchor}
          offsetTop={isMobile && !isWebView ? MOBILE_HEADER_HEIGHT_APPROX : 0}
          onChange={(currentActiveLink) => {
            if (currentActiveLink) {
              const spanRef = getRef<HTMLSpanElement>(currentActiveLink.replace('#', ''));
              const wrapper = getRef<any>('wrapper')?.current;
              if (wrapper && spanRef) {
                wrapper.scrollTo({
                  left: spanRef.current.getBoundingClientRect().left + wrapper.scrollLeft - 18,
                  behavior: 'smooth',
                });
              }
            }
          }}
        >
          <ul className={styles.navContainer} ref={setRef('wrapper')}>
            <li>
              <Anchor.Link
                href={`#${StatePageIds.top_lakes}`}
                title={
                  <span ref={setRef(StatePageIds.top_lakes)}>
                    <span role="img" aria-label="map-of-lakes-icon" className={styles.lakeIcon}>
                      <SvgLakes />
                    </span>{' '}
                    Top Lakes
                  </span>
                }
              />
            </li>
            <li>
              <Anchor.Link
                href={`#${StatePageIds.stats}`}
                title={
                  <span ref={setRef(StatePageIds.stats)}>
                    <span
                      role="img"
                      aria-label="fishing-reports-icon"
                      className={styles.fishingReportsIcon}
                    >
                      <SvgFishingReport />
                    </span>
                    Stats
                  </span>
                }
              />
            </li>

            <li>
              <Anchor.Link
                href={`#${StatePageIds.popular}`}
                title={
                  <span ref={setRef(StatePageIds.popular)}>
                    <span role="img" aria-label="product-icon" className={styles.productIcon}>
                      <SvgProducts />
                    </span>
                    Products
                  </span>
                }
              />
            </li>
            {!!mediaCount && (
              <li>
                <Anchor.Link
                  href={`#${StatePageIds.videos_articles}`}
                  title={
                    <span
                      ref={setRef(StatePageIds.videos_articles)}
                      // to do: add analytics to state page in upcoming story
                      //   onClick={webAnalyticsLakePageClick('[pg_navigation].(left_nav)')}
                    >
                      <span role="img" aria-label="media-folder-icon" className={styles.mediaIcon}>
                        <SvgVideoFolder />
                      </span>{' '}
                      Videos & Articles
                    </span>
                  }
                />
              </li>
            )}
            {hasLearnMoreSection && (
              <li>
                <Anchor.Link
                  href={`#${StatePageIds.questions}`}
                  title={
                    <span
                      ref={setRef(StatePageIds.questions)}
                      // to do: add analytics to state page in upcoming story
                      // onClick={webAnalyticsLakePageClick('[pg_navigation].(left_nav)')}
                    >
                      <span role="img" aria-label="info-icon" className={styles.learnMoreIcon}>
                        <SvgInfo />
                      </span>
                      Learn More
                    </span>
                  }
                />
              </li>
            )}
          </ul>
        </Anchor>
      </ContentWrapper>
    </div>
  );
};
